// packages/world-model/src/traits/flammable/index.ts

export * from './flammableTrait.js';
